import { render, staticRenderFns } from "./DynamicLink.vue?vue&type=template&id=11820c8d"
import script from "./DynamicLink.vue?vue&type=script&lang=js"
export * from "./DynamicLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11820c8d')) {
      api.createRecord('11820c8d', component.options)
    } else {
      api.reload('11820c8d', component.options)
    }
    module.hot.accept("./DynamicLink.vue?vue&type=template&id=11820c8d", function () {
      api.rerender('11820c8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/inc/DynamicLink.vue"
export default component.exports